export default "__VITE_ASSET__BOxXzpI9__"